import Box from "@mui/material/Box";
import Header from "./Header";
import Menu from "./Menu";
import Loader from "pages/components/Loader";
import { getCurrentUserData } from "Application/User/UserService";

export default function Layout(props: any) {
  const children = props.children;

  return (
    <Box sx={{ display: "flex", width: "100%", backgroundColor: "lightgray" }}>
      {getCurrentUserData().isCreditorValidated() && <Menu />}
      <Box
        component="section"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <Header open={false} />
        <Box
          sx={{
            flexGrow: 1,
            margin: 1.6,
            backgroundColor: "white",
            borderRadius: 2,
            padding: 3,
            maxWidth: "100vw",
          }}
        >
          <Box
            sx={{
              position: "fixed",
              right: 0,
              marginTop: 0,
              marginRight: "30px",
            }}
          >
            <Loader />
          </Box>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
